import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { LogOut, Flame, Inbox, Quote, CalendarDays, Languages, BellRing, Sun, Users, LayoutDashboard, IndianRupee } from "lucide-react";
import Seo from "../components/Seo";
import { useAuth } from "../context/AuthContext";
import { SITE } from "../i18n/translations";
import EnquiriesPanel from "../components/admin/EnquiriesPanel";
import TestimonialsPanel from "../components/admin/TestimonialsPanel";
import FestivalsPanel from "../components/admin/FestivalsPanel";
import ContentPanel from "../components/admin/ContentPanel";
import RemindersPanel from "../components/admin/RemindersPanel";
import DarshanPanel from "../components/admin/DarshanPanel";
import SubscribersPanel from "../components/admin/SubscribersPanel";
import TodayPanel from "../components/admin/TodayPanel";
import AstroPaymentsPanel from "../components/admin/AstroPaymentsPanel";

const TABS = [
  { id: "today", label: "Today", icon: LayoutDashboard },
  { id: "enquiries", label: "Enquiries", icon: Inbox },
  { id: "astro-payments", label: "Astrology Payments", icon: IndianRupee },
  { id: "testimonials", label: "Testimonials", icon: Quote },
  { id: "festivals", label: "Calendar", icon: CalendarDays },
  { id: "reminders", label: "Reminders", icon: BellRing },
  { id: "darshan", label: "Daily Darshan", icon: Sun },
  { id: "subscribers", label: "Subscribers", icon: Users },
  { id: "content", label: "Translations", icon: Languages },
];

export default function AdminDashboard() {
  const { logout, user } = useAuth();
  const navigate = useNavigate();
  const [tab, setTab] = useState("today");

  const doLogout = async () => { await logout(); navigate("/admin/login"); };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-testid="admin-dashboard">
      <Seo title="Admin Dashboard" description="Enquiry management" path="/admin" />

      <div className="flex flex-wrap items-center justify-between gap-4 mb-7">
        <div className="flex items-center gap-3">
          <span className="flex h-11 w-11 items-center justify-center rounded-full bg-gradient-to-br from-tara-gold to-tara-vermilion">
            <Flame className="h-5 w-5 text-white" />
          </span>
          <div>
            <h1 className="font-serif text-2xl font-bold gold-text leading-tight">Studio</h1>
            <p className="text-xs text-tara-muted">{user?.name || SITE.practitioner}</p>
          </div>
        </div>
        <button onClick={doLogout} className="flex items-center gap-2 rounded-full border border-red-500/40 px-4 py-2 text-sm text-red-700 hover:bg-red-500/10 transition" data-testid="admin-logout-btn">
          <LogOut className="h-4 w-4" /> Logout
        </button>
      </div>

      <div className="glass rounded-full p-1.5 inline-flex flex-wrap gap-1 mb-8" data-testid="admin-tabs">
        {TABS.map((x) => (
          <button
            key={x.id}
            onClick={() => setTab(x.id)}
            className={`flex items-center gap-2 rounded-full px-5 py-2.5 text-sm font-semibold transition-all ${
              tab === x.id
                ? "bg-gradient-to-r from-tara-gold to-tara-vermilion text-white shadow-soft"
                : "text-tara-body hover:text-tara-sindoor"
            }`}
            data-testid={`admin-tab-${x.id}`}
          >
            <x.icon className="h-4 w-4" /> {x.label}
          </button>
        ))}
      </div>

      {tab === "today" && <TodayPanel onNavigate={setTab} />}
      {tab === "enquiries" && <EnquiriesPanel />}
      {tab === "astro-payments" && <AstroPaymentsPanel />}
      {tab === "testimonials" && <TestimonialsPanel />}
      {tab === "festivals" && <FestivalsPanel />}
      {tab === "reminders" && <RemindersPanel />}
      {tab === "darshan" && <DarshanPanel />}
      {tab === "subscribers" && <SubscribersPanel />}
      {tab === "content" && <ContentPanel />}
    </div>
  );
}
